import { SEARCH_USER_EVENTS, CLEAR_SEARCH_USER_EVENTS } from 'actions/Types';

export default (state = [], action) => {
  if (action.type === `${SEARCH_USER_EVENTS}_SUCCESS`) {
    return action.payload;
  }
  if (action.type === CLEAR_SEARCH_USER_EVENTS) return [];

  return state;
};
